import { useState, useEffect } from 'react';
import first from 'lodash.first';

import { byTotal as filterByTotalEngagement } from 'components/data-containers/SocialTopPosts/utils/useSocialTopPostsData';
import {
  ITopPost,
  IPlatform,
  IPlatformItem,
  IPlatformAndEntity,
} from './../types';

const useSocialTopPostsData = (
  platforms: ITopPost[]
): IPlatformAndEntity | undefined => {
  const [post, setPost] = useState();

  useEffect(() => {
    if (!platforms) return;

    const topPosts = platforms
      .flatMap(filterTotalEngagementPlatforms)
      .flatMap(normalizeForUIComponents)
      .filter(filterPostsWithData)
      .sort(sortByValue);

    setPost(first<any>(topPosts));
  }, [platforms]);

  return post;
};

function filterTotalEngagementPlatforms(entity: ITopPost): ITopPost {
  const data = entity.data.filter(filterByTotalEngagement);
  return { ...entity, data };
}

function normalizeForUIComponents(entity: ITopPost): IPlatformAndEntity[] {
  const platforms = entity.data;
  return platforms.flatMap(mapOverPosts);

  function mapOverPosts(platform: IPlatform): IPlatformAndEntity[] {
    const { platformId: id, platformName: name, data: posts } = platform;
    return posts.map(addEntityAndPlatform);

    function addEntityAndPlatform(post: IPlatformItem): IPlatformAndEntity {
      return { ...post, platform: { id, name }, entity: entity.entity };
    }
  }
}

function filterPostsWithData(post: IPlatformAndEntity): number | null | '' {
  return post.content && post.value;
}

function sortByValue(
  left: IPlatformAndEntity,
  right: IPlatformAndEntity
): number {
  return Number(right.value) - Number(left.value); // descending
}

export default useSocialTopPostsData;
